module.exports = __webpack_public_path__ + "static/media/2.-Interview--illustration.db0ebe3b.svg";